module.exports = __webpack_public_path__ + "catalog/items/smoke-detector/smokeDetector.png";